// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"169":"4f46df78","2052":"93f72cc2","7813":"63aac63b"}[chunkId] + ".css";
};